export default __webpack_public_path__ + "static/media/seraph.da861bc2.png";